import styled from 'styled-components/macro';

export const SpinnerWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '300px',
});
